import React from 'react';
import Joi from 'joi-browser';
import Form from './common/form';
import { getCredit, saveCredit } from '../services/creditService';
import { getTradeTypes } from '../services/tradeTypeService';

class CreditForm extends Form {
  state = {
    data: {
      user_email: '',
      tradeTypeId: '',
      amount: '',
      trade_reference: '',
    },
    ttypes: [],
    errors: {},
  };

  schema = {
    _id: Joi.string(),
    user_email: Joi.string().required().label('User Email'),
    trade_reference: Joi.string().required().label('Trade Reference'),
    tradeTypeId: Joi.string().required().label('Trade Type'),
    amount: Joi.number().required().label('Amount'),
  };

  async populateTradeTypes() {
    const { data: ttypes } = (await getTradeTypes()).data;
    this.setState({ ttypes });
  }

  async populateCredit() {
    try {
      const creditId = this.props.match.params.id;
      if (creditId === 'new') return;

      const { data: credit } = (await getCredit(creditId)).data;
      this.setState({ data: this.mapToViewModel(credit) });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        return this.props.history.replace('/not-found');
    }
  }

  async componentDidMount() {
    await this.populateTradeTypes();
    await this.populateCredit();
  }

  mapToViewModel(credit) {
    return {
      _id: credit._id,
      amount: credit.amount,
      trade_reference: credit.trade_reference,
      tradeTypeId: credit.trade_type._id,
      user_email: credit.user_email,
    };
  }

  doSubmit = async () => {
    const { data } = this.state;
    // Call the server

    console.log(data)

    await saveCredit(data);

    this.props.history.push('/credits');
  };

  render() {
    const creditId = this.props.match.params.id;
    return (
      <div className="row">
        <div className="col-md-6 offset-md-3" style={{ marginTop: 50 + 'px' }}>
          <div className="text-center">
            <h4
              className="h4 mb-2 login-welcome-text"
              style={{ marginTop: 20 + 'px', fontWeight: 'bold' }}
            >
              Credit User Wallet
            </h4>
            <p style={{ color: '#000524' }}>
              This operation can only be performed by Jeroid Admin
            </p>
          </div>
          <div
            className="card card-register mx-auto mt-2"
            style={{ border: 0, borderRadius: 0, marginBottom: 10 + '%' }}
          >
            <div
              className="card-header"
              style={{
                backgroundColor: 'white',
                borderBottom: 0,
                marginTop: 2 + '%',
                fontWeight: 'bold',
              }}
            >
              Transaction Info
            </div>
            <hr
              style={{
                marginRight: 20 + 'px',
                marginLeft: 20 + 'px',
                marginTop: 0,
                marginBottom: 0,
              }}
            />
            <div className="card-body">
              <form onSubmit={this.handleSubmit}>
                <div className="form-row">
                  <div className="col-md-6">
                    {this.renderInput(
                      'user_email',
                      'User Email',
                      '',
                      'autofocus',
                      'text'
                    )}
                  </div>
                  <div className="col-md-6">
                    {this.renderInput(
                      'trade_reference',
                      'Trade Reference',
                      '',
                      '',
                      'text'
                    )}
                  </div>
                </div>

                <div className="form-row">
                  <div className="col-md-6">
                    {this.renderInput('amount', 'Amount', '', '', 'number')}
                  </div>
                  <div className="col-md-6">
                    {this.renderRegSelect(
                      'tradeTypeId',
                      'Trade Type',
                      this.state.ttypes
                    )}
                  </div>
                </div>

                <div className="text-center">
                  {creditId === 'new'
                    ? this.renderButton('Save')
                    : this.renderButton('Update')}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CreditForm;
